import { kyber } from 'kyber-crystals';

/**
 * Derives the shared secret from a Kyber ciphertext using the receiver's private key.
 * Used to complete the handshake confirmation flow.
 *
 * @param receiverKyberPrivateKey - Receiver's Kyber private key
 * @param ciphertext - Encapsulated ciphertext from the handshake confirm message
 * @returns Shared secret as Uint8Array
 */
export async function deriveKyberSecret({
  receiverKyberPrivateKey,
  ciphertext,
}: {
  receiverKyberPrivateKey: Uint8Array;
  ciphertext: Uint8Array;
}): Promise<Uint8Array> {
  const sharedSecret = await kyber.decrypt(ciphertext, receiverKyberPrivateKey);
  return sharedSecret;
}